import { createSlice } from '@reduxjs/toolkit';

const branchesCookie = localStorage.getItem('branches');
const initialStateValue = { branches: '', branchId: 0, id: 0, record: '', loginBranches: undefined };

export const userBranchesSlice = createSlice({
  name: 'userBranches',
  initialState: {
    value: {
      ...initialStateValue,
      branches: branchesCookie ? JSON.parse(branchesCookie) : '',
      branchId: branchesCookie && JSON.parse(branchesCookie)[0]?.branchInfo.jetId,
      id: branchesCookie && JSON.parse(branchesCookie)[0]?.branchInfo?.accountId,
      record: branchesCookie && JSON.parse(branchesCookie)[0],
    },
  },
  reducers: {
    userBranches: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    removeUserBranches: (state) => {
      state.value = initialStateValue;
    },
    setUserLoginBranches: (state, { payload }) => {
      state.value = { ...state.value, loginBranches: payload };
    },
  },
});

export const { userBranches, removeUserBranches, setUserLoginBranches } = userBranchesSlice.actions;

export default userBranchesSlice.reducer;
